var map = {
	"./android-chrome-192x192.png": 844,
	"./android-chrome-512x512.png": 980,
	"./apple-touch-icon.png": 419,
	"./browserconfig.xml": 435,
	"./favicon-16x16.png": 142,
	"./favicon-32x32.png": 322,
	"./favicon.ico": 601,
	"./mstile-150x150.png": 516,
	"./safari-pinned-tab.svg": 425,
	"./site.webmanifest": 222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;